// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "index/css/" + chunkId + "." + {"127":"663581c8","242":"a7eb84e1","632":"86f8a37c","905":"a7eb84e1"}[chunkId] + ".chunk.css";
};